import React from 'react';
import {
  Global,
  TemplateProps,
} from '../../../../../constants';
import { ChargeReceivable } from '../ChargeReceivable';
import {
  FlexLayout,
  GridLayout,
  LayoutTitle,
} from '../../../../../components';
import { WeekendLongReceivablesTabGridHeader } from '../heades/WeekendLongReceivablesTabGridHeader';
import { Date6Calculator } from '../../../../../utils/time';


export const WeekendLongReceivablesTemplate: React.FC<TemplateProps<ChargeReceivable>> = ({
  scope,
}) => (
  <FlexLayout isVertical={true}>
    <LayoutTitle justify="left">
      <span style={{ color: 'var(--color-red)' }}>* 3달이상된 장기미수금액의 수금내역입니다. (미수기준월 :
        {new Date6Calculator(scope.state.yearmon).add(-3).toString().slice(0, 4)}년
        {new Date6Calculator(scope.state.yearmon).add(-3).toString().slice(4, 6)}월 )</span>
    </LayoutTitle>
    <GridLayout
      ref={scope.gridWeekendLongReceivable}
      header={WeekendLongReceivablesTabGridHeader(scope)}
      rowHeight={Global.LAYOUT_GRID_HEIGHT_1}
      data={scope.state.dataWeekendLongReceivable}
      onRowClick={(item) => scope.onRowFocusEvent(item)}
    elGrid="dataWeekendLongReceivable"
    />
  </FlexLayout>
);
